// extracted by mini-css-extract-plugin
export default {"twoColumnSection":"styles_twoColumnSection__IW1ms","columns":"styles_columns__m1UBG","column":"styles_column__8O0fY","gifImage":"styles_gifImage__gwGJG"};